(() => {
  const SUBMIT_SELECTOR = 'xo-cart-discount-submit';

  function getCartSectionIds() {
    const ids = [];

    const cartMini = document.querySelector('xo-cart-mini[id]');
    const cart = document.querySelector('xo-cart[id]');

    if (window.location.pathname.includes('/cart') && cart?.id) {
      ids.push(cart.id);
    }

    if (cartMini?.id) {
      ids.push(cartMini.id);
    }

    return [...new Set(ids)].slice(0, 5);
  }

  function saveDiscountInXO(code) {
    if (!window.xoStore?.set) return;

    window.xoStore.set('xo-cart-discount', (state) => ({
      ...(state || {}),
      discount: code
    }));
  }

  function updateXOCart(data) {
    if (!window.xoStore?.set) {
      window.location.reload();
      return;
    }

    window.xoStore.set('xo-cart', (state) => ({
      ...(state || {}),
      size: data.item_count,
      sections: data.sections || state?.sections || {},
      changeLineLoading: -1
    }));
  }

  function closeDiscountModal(element) {
    const modal = element.closest('xo-modal');

    if (modal && window.xoModal?.close) {
      const name = modal.getAttribute('xo-name');

      if (name) {
        window.xoModal.close(name);
      }
    }
  }

  function showError(message) {
    if (window.xoToast?.push) {
      window.xoToast.push({
        content: message,
        placement: 'top-center',
        delay: 4000
      });
    } else {
      alert(message);
    }
  }

  document.addEventListener(
    'click',
    async (event) => {
      const submit = event.target.closest(SUBMIT_SELECTOR);

      if (!submit) return;

      /*
       * Impede que o comportamento original do tema execute.
       * O XO atualmente apenas salva o código localmente e fecha o modal.
       */
      event.preventDefault();
      event.stopImmediatePropagation();

      const discountComponent = submit.closest('xo-cart-discount');
      const input = discountComponent?.querySelector(
        'input[type="text"][name="discount"]'
      );

      if (!input) return;

      const code = input.value.trim();

      submit.setAttribute('xo-loading', '');

      try {
        const sections = getCartSectionIds();

        const response = await fetch(
          `${window.Shopify.routes.root}cart/update.js`,
          {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              discount: code,
              sections: sections,
              sections_url: window.location.pathname
            })
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.description ||
              data.message ||
              'No se pudo aplicar el cupón.'
          );
        }

        saveDiscountInXO(code);

        /*
         * Fecha o modal antes de o mini cart ser substituído
         * pelo HTML atualizado.
         */
        closeDiscountModal(submit);

        /*
         * Faz o XO atualizar:
         * - total
         * - descontos
         * - barra de frete grátis
         * - quantidade
         */
        updateXOCart(data);
      } catch (error) {
        console.error('[Bumker cart discount]', error);

        showError(
          'No pudimos aplicar el cupón. Revisá el código e intentá nuevamente.'
        );
      } finally {
        submit.removeAttribute('xo-loading');
      }
    },
    true
  );

  document.addEventListener(
    'click',
    async (event) => {
      const removeButton = event.target.closest('.bumker-remove-discount');

      if (!removeButton) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      removeButton.disabled = true;
      removeButton.style.opacity = '0.4';

      try {
        const sections = getCartSectionIds();

        const response = await fetch(
          `${window.Shopify.routes.root}cart/update.js`,
          {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              discount: '',
              sections: sections,
              sections_url: window.location.pathname
            })
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.description ||
            data.message ||
            'No se pudo quitar el cupón.'
          );
        }

        saveDiscountInXO('');
        updateXOCart(data);
      } catch (error) {
        console.error('[Bumker remove discount]', error);

        removeButton.disabled = false;
        removeButton.style.opacity = '';

        showError(
          'No pudimos quitar el cupón. Intentá nuevamente.'
        );
      }
    },
    true
  );
})();